<template>
  <div>
    <!-- Progress Circular always shows when loaderStore.isLoading is true -->
    <v-progress-circular
      v-if="loaderStore.isLoading"
      :size="24"
      indeterminate
      color="primary"
      class="ma-2"
    />
    <!-- Badge only shows when getLoadingCount is greater than 1 -->
    <v-badge
      v-if="loaderStore.getLoadingCount > 1"
      :content="loaderStore.getLoadingCount"
    />
  </div>
</template>

<script setup lang="ts">
  import { useLoaderStore } from '@/store/loaderStore';

  const loaderStore = useLoaderStore();
</script>
